import type { i18n as I18n } from 'i18next';
import { DateTime } from 'luxon';

export type DateFormatKind = 'date' | 'dateTime' | 'dateTimeSeconds' | 'time';

const PRESETS: Record<DateFormatKind, Intl.DateTimeFormatOptions> = {
  date: DateTime.DATE_SHORT,
  dateTime: DateTime.DATETIME_SHORT,
  dateTimeSeconds: DateTime.DATETIME_SHORT_WITH_SECONDS,
  time: DateTime.TIME_SIMPLE,
};

export interface FormatOptions {
  zone?: 'utc' | 'local';
}

export const formatLocalized = (
  value: Date | string | null | undefined,
  kind: DateFormatKind,
  i18n: I18n,
  { zone = 'local' }: FormatOptions = {},
): string => {
  if (value == null || value === '') return '';
  const parseOpts = zone === 'utc' ? { zone: 'utc' } : undefined;
  const dt =
    typeof value === 'string'
      ? DateTime.fromISO(value, parseOpts)
      : DateTime.fromJSDate(value, parseOpts);
  if (!dt.isValid) return '';
  const zoned = zone === 'utc' ? dt.toUTC() : dt.toLocal();
  return zoned.setLocale(i18n.language).toLocaleString(PRESETS[kind]);
};
